import { render, staticRenderFns } from "./audioDetail.vue?vue&type=template&id=0cbe053e&scoped=true"
import script from "./audioDetail.vue?vue&type=script&lang=js"
export * from "./audioDetail.vue?vue&type=script&lang=js"
import style0 from "./audioDetail.vue?vue&type=style&index=0&id=0cbe053e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbe053e",
  null
  
)

export default component.exports